var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dental fillings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dental_fillings",
    "data-name": "dental fillings"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,30.46a12.67,12.67,0,0,0-9-10.94C43.51,23.15,38.33,26,32,26s-11.51-2.85-12-6.48a12.67,12.67,0,0,0-9,10.94,12.53,12.53,0,0,0,2.82,9.13,17.86,17.86,0,0,1,3.56,7.75c.68,3.33,1.53,7.47,2.12,10.31a4.2,4.2,0,0,0,8.19.15l1.81-7.41a2.52,2.52,0,0,1,4.9,0l1.81,7.41a4.2,4.2,0,0,0,8.19-.15c.59-2.84,1.44-7,2.12-10.31a17.86,17.86,0,0,1,3.56-7.75A12.53,12.53,0,0,0,53,30.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,10v7.62l-2.29-2.3a1,1,0,0,0-1.42,1.42l4,4a1,1,0,0,0,.33.21.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21l4-4a1,1,0,0,0-1.42-1.42L33,17.59V10c5.87-.28,10.54-3,11-6.45a11.61,11.61,0,0,0-2.43-.47,12.5,12.5,0,0,0-5.21.63,13.19,13.19,0,0,1-8.64,0,12.5,12.5,0,0,0-5.21-.63A11.61,11.61,0,0,0,20,3.52C20.47,7,25.14,9.69,31,10Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillings);
export default __webpack_public_path__ + "static/media/fillings.bef1caeaef0dad7ef196cfd2b01c7d15.svg";
export { ForwardRef as ReactComponent };